import type { SVGProps } from 'react';

const SvgPickerArrowDownFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929L18.2929 9.7071C18.9229 9.07714 18.4767 8 17.5858 8H6.41421C5.52331 8 5.07714 9.07714 5.70711 9.70711L11.2929 15.2929Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgPickerArrowDownFilled;
